/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { createRef, useEffect, useState } from 'react';
import type { RefObject } from 'react';

import { Grid } from '@coursera/cds-core';

import CourseraLiteLogo from 'bundles/coursera-plus-landing-page/components/heroContentful/CourseraLiteLogo';
import CourseraPlusLogo from 'bundles/coursera-plus-landing-page/components/heroContentful/CourseraPlusLogo';
import DesignArea from 'bundles/coursera-plus-landing-page/components/heroContentful/DesignArea';
import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';

const itemPadding = '20px';

const styles = {
  container: () => css`
    background: #eee;
    max-width: 1500px;
    margin-left: auto;
    margin-right: auto;
    wrap: no-wrap; /* stylelint-disable-line property-no-unknown */
  `,
  wideItem: () => css`
    padding: ${itemPadding};
  `,
};

const shouldShowImage = (narrow: RefObject<HTMLDivElement>, wide: RefObject<HTMLDivElement>): boolean => {
  const narrowDiv = narrow?.current ?? null;
  const wideDiv = wide?.current ?? null;
  if (!narrowDiv || !wideDiv) {
    return false;
  }
  return wideDiv.getBoundingClientRect().y === narrowDiv.getBoundingClientRect().y;
};

type ShowImageProps = {
  shouldShow: boolean;
  url: string | null;
};
const ShowImage = ({ shouldShow, url }: ShowImageProps) => {
  if (!shouldShow) {
    return null;
  }
  if (!url) {
    return null;
  }
  return <img src={url} alt="" style={{ maxWidth: '90%' }} />;
};

type PropsToDesign = { isCourseraLiteContentfulPage: boolean };

/* This is just to test the flexible design concept - by no means a design suggestion */
const TestDesign = ({ isCourseraLiteContentfulPage }: PropsToDesign) => {
  const landingPageExtended = useLandingPageExtended();
  const imgUrl = landingPageExtended?.landingPage?.heroImage?.url ?? null;
  const [showImage, setShowImage] = useState<boolean>(false);
  const narrow = createRef<HTMLDivElement>();
  const wide = createRef<HTMLDivElement>();
  const checkLayout = () => {
    setShowImage(shouldShowImage(narrow, wide));
  };
  useEffect(() => {
    checkLayout();
    window.addEventListener('resize', checkLayout);
    return () => {
      window.removeEventListener('resize', checkLayout);
    };
  });

  return (
    <div className="rc-TestDesign" style={{ padding: '50px' }}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        css={styles.container}
        alignContent="center"
        xs={12}
        sm={12}
      >
        <Grid item xs={12} sm={5} css={styles.wideItem}>
          <div ref={wide} />
          {isCourseraLiteContentfulPage ? <CourseraLiteLogo /> : <CourseraPlusLogo />}
          <DesignArea areaId={1} />
        </Grid>
        <Grid item sm={2} xs={12}>
          <div ref={narrow} style={{ marginTop: itemPadding }}>
            <ShowImage shouldShow={showImage} url={imgUrl} />
          </div>
        </Grid>
        <Grid item sm={5} xs={12} css={styles.wideItem}>
          <DesignArea areaId={2} />
        </Grid>
      </Grid>
    </div>
  );
};

export default TestDesign;
